import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import _ from 'lodash';
import { showModal } from '../../actions';
import { addFlashMessage } from '../../helpers/FlashMessages';

const PinCreateSmartCollection = ({
  openNewCollectionModal,
  selectedFilters,
  collection,
}) => {
  const intl = useIntl();

  const handleNewCollectionModal = () => {
    if (collection && collection.smart) {
      const smartFilters = collection.attributes?.filters ? collection.attributes.filters : [];
      openNewCollectionModal(intl, _.uniq([...selectedFilters, ...smartFilters]));
    } else {
      openNewCollectionModal(intl, selectedFilters);
    }
  };

  return (
    <>
      {/* eslint-disable jsx-a11y/click-events-have-key-events */}
      <div
        id="PinCreateSmartCollection"
        className="smart-collection-button"
        role="button"
        onClick={handleNewCollectionModal}
        tabIndex={0}
      >
        <span className="text-glow-violet">
          <i className="fas fa-bolt" />
        </span>
      </div>
      {/* eslint-enable jsx-a11y/click-events-have-key-events */}
      <UncontrolledTooltip fade={false} placement="top" target="PinCreateSmartCollection">
        {intl.formatMessage({ defaultMessage: 'Create Smart Collection' })}
      </UncontrolledTooltip>
    </>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  collection: state.Collections.collection,
});

const mapDispatchToProps = dispatch => ({
  openModal: (params) => {
    dispatch(showModal('PinSearchModal', params));
  },
  openNewCollectionModal: (intl, selectedFilters) => {
    dispatch(showModal('CollectionEditModal', {
      className: 'modal-edit-collection',
      afterCreateCollection: (collection) => {
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'A new Collection has been created' }),
          button: {
            url: `/collections/${collection.uuid}`,
            text: intl.formatMessage({ defaultMessage: 'Open Collection' }),
          },
        });
      },
      smart: true,
      selectedFilters,
    }));
  },
});

PinCreateSmartCollection.propTypes = {
  openNewCollectionModal: PropTypes.func.isRequired,
  selectedFilters: PropTypes.array.isRequired,
  collection: PropTypes.object,
};

PinCreateSmartCollection.defaultProps = {
  collection: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(PinCreateSmartCollection);
